var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"project-internal-orders"},[_c('a-table',{attrs:{"columns":_vm.columns,"dataSource":_vm.internalOrders,"rowClassName":() => 'orders__table-row',"rowKey":(record) => record.key,"pagination":{ pageSize: 5 }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }